module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h11"
  }, [_c('span', {
    staticClass: "th12"
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_vm._v("I have wanted to write a “dinosaur novel” for I don’t know how long; I am, unashamedly, one of the biggest dinosaur nerds in the world. Thank you to all the people who supported me on the journey of bringing "), _c('span', {
    staticClass: "t9"
  }, [_vm._v("Jurassic Heart")]), _vm._v(" to life—Tush, MJ, and Aleks, and the girls who read the beginning and helped make it shine; to Michael Crichton and Steven Spielberg for igniting a little girl’s passion in long-since extinct animals; Carrie-Anne, who came with me to the Natural History Museum on a dinosaur-seeking mission. And Emily, for the Triceratops named Horny who inspired a tradition.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c385e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/005.vue
// module id = 66
// module chunks = 0